import React from 'react'
import classNames from 'classnames'
import './BorderedBox.less'
import { Box } from 'front-end/src/components'

const BorderedBox = ({
  children,
  className
}: {
  children: any
  className?: string
}) => {
  return <div className={classNames('BorderedBox', className)}>{children}</div>
}

export default BorderedBox

export const BorderedBoxStats = ({
  stats = []
}: {
  stats: Array<{
    className?: string
    caption: React.ReactNode | string
    value: string | number
  }>
}) => {
  return (
    <Box className="BorderedBox__stats">
      <ul>
        {stats.map((stat) => {
          const hasValue = stat.value !== '-'

          return (
            <li
              key={stat.className}
              className={classNames(stat.className, {
                'no-value': !hasValue,
                'has-value': hasValue
              })}
            >
              {stat.caption}
              <strong>{stat.value}</strong>
            </li>
          )
        })}
      </ul>
    </Box>
  )
}
